// utensils/StatusBoardContext.js
import React, { createContext, useContext, useState, useMemo } from "react";

// Crear el contexto
const StatusBoardContext = createContext(null);

// Hook para acceder al contexto
export const useStatusBoard = () => useContext(StatusBoardContext);

// Proveedor
export const StatusBoardProvider = ({ children }) => {
  // Estados base
  const [selectedDay, setSelectedDay] = useState(1); // Día por defecto
  const [selectedIngesta, setSelectedIngesta] = useState(1); // Ingesta por defecto
  const [selectedExercise, setSelectedExercise] = useState(null); // Ejercicio seleccionado

  /**
   * Limpia la selección actual:
   * - Resetea el día a 1
   * - Resetea la ingesta a 1
   * - Elimina el ejercicio seleccionado
   */
  const clearSelection = () => {
    setSelectedExercise(null);
    setSelectedDay(1);
    setSelectedIngesta(1);
  };

  // (Opcional) Helper para seleccionar un ejercicio y mover el día si hace falta
  const selectExercise = (exercise, day = null) => {
    setSelectedExercise(exercise || null);
    if (day !== null && Number.isInteger(day)) setSelectedDay(day);
  };

  const value = useMemo(
    () => ({
      selectedDay,
      setSelectedDay,
      selectedIngesta,
      setSelectedIngesta,
      selectedExercise,
      setSelectedExercise,
      clearSelection, // 👈 exportado para usar en logout
      selectExercise, // 👈 helper opcional
    }),
    [selectedDay, selectedIngesta, selectedExercise]
  );

  return (
    <StatusBoardContext.Provider value={value}>
      {children}
    </StatusBoardContext.Provider>
  );
};
